import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { ASSIST, PAPER} from '../../../utils/questionManageType';
import { Layout,Pagination, Tabs, Button, Alert, Input, Tag, Row, Col, Spin, Tooltip, Badge, Icon,Tree ,Cascader} from 'antd';
const TreeNode = Tree.TreeNode;

const TabPane = Tabs.TabPane;
let onOff = true;
class AllowTabs extends Component {
    state = {
        tab:[],
        selectedKeys:[],
    }
    componentDidMount() {
		//不清楚此处传参，排除字词库传参情况
        if (this.props.location.search.length > 0&&!this.props.location.search.includes('cateitem')) {
            let paramStr =  this.props.location.search.slice(1);
            const newArr = paramStr.split('&');
            const newObj = {};
            newArr.forEach((item) => {
                let innerArr = item.split('=');
                newObj[innerArr[0]] = innerArr[1];
            });
            let type = newObj.type;
            let casDate = newObj.casDate.split(',');
            let lastValue = newObj.lastValue.split(',');
            let questionId = newObj.questionId;
            this.props.setDefaultAssistList(casDate);
            setTimeout(() => {
                this.props.handleTreeSelect(lastValue, type);
                this.props.onSearchChange(questionId);
                this.setState({selectedKeys: lastValue});
            },0)
        }
        
        if (this.props.expandedKeys && this.props.expandedKeys.length) {
            this.setState({expandedKeys: this.props.expandedKeys})
        }
        if (this.props.selectedKeys!=undefined ) {
            this.setState({selectedKeys: this.props.selectedKeys})
        }

    }
    tabChange = key => {
        const { handleTableChange } = this.props;
		this.setState({selectedKeys: this.props.selectedKeys})
		handleTableChange(key);
    }
    createHtml = str => ({ __html: str ? str : `&nbsp;` });

    //关掉多层（因设置expandedKeys后无法自动关掉多层）
    onTreeExpand=(expandedKeys,obj,list)=>{
        let expandedKeysSet = new Set(expandedKeys)
        if(!obj.expanded){
            const loop = (data, key, callback) => {
                data.forEach((item, index, arr) => {
                    if (item.id == key) {
                        return callback(item, index, arr);
                    }
                    if (item.list) {
                        return loop(item.list, key, callback);
                    }
                });
            };
            //所有节点执行cb的loop
            const loopAll = (data, callback) => {
                data.forEach((item, index, arr) => {
                    callback(item, index, arr);
                    if(item.list) {
                        return loopAll(item.list, callback);
                    }
                });
            };
            loop(list, obj.node.props.eventKey, (item, index, arr) => {
                //目标节点下的所有节点从expandedKeys中移除
                item.list&&loopAll(item.list,(item1)=>{
                    expandedKeysSet.delete(item1.id)
                })
            });
        }
        this.setState({expandedKeys:[...expandedKeysSet],autoExpandParent: false,})
        if(this.props.setExpandedKeys){this.props.setExpandedKeys([...expandedKeysSet])}
    }
    render() {
        const { data, size="default", treeList, defaultAssistList, loading, handleGetPaperTreeList,handleAssistChange, handleTreeSelect, assistList={list:[]} } = this.props;
        const loopCascader = data => data.map(item => {
            let option = { value: item.assist_id || item.book_id || item.edition_id, label: item.name }
            if (item.list) option.children = loopCascader(item.list)
            return option;
        })
        const loop = data => data.map((item) => {
            if (item.list) {

                return (
                    <TreeNode key={ item.id }  title = { <div style={{whiteSpace:'pre-wrap',paddingRight:'24px'}} title={item.name} dangerouslySetInnerHTML = { {__html:item.question_count === undefined ? item.name :`${item.name}<span style="color: #42bda4;margin-left: 10px;"">总题数：</span><span style="color: #0d84c3;">${item.question_count}</span> <span style="color: #42bda4;margin-left: 10px;">打标签数：</span><span style="color: #0d84c3;">${item.question_count_select}</span><span style="color: #42bda4;margin-left: 10px;">返工数：</span><span style="color: #0d84c3;">${item.question_count_checkrework}</span>`} }/> }>
                        {loop(item.list)}
                    </TreeNode>
                );
            }
            return <TreeNode key={ item.id } title = { <div style={{whiteSpace:'pre-wrap',paddingRight:'24px'}} title={item.name} dangerouslySetInnerHTML = { this.createHtml(item.name) }/> } />;
        });
        return (
            <Tabs size = { size } defaultActiveKey = { data ? data[0].type + '' : '' } onChange = { this.tabChange }>
                {

                    data.map((v,k) =>
                        <TabPane tab={ v.title } key = { v.type }>
                            {
                                v.type == ASSIST &&
                                <Cascader allowClear={ false }
                                          value = {defaultAssistList.length > 0 ? defaultAssistList : []}
                                          style={{width:"100%"}}
                                          options={loopCascader(assistList.list || []) }
                                          onChange={ (value, selectedOptions) =>  handleAssistChange(value, selectedOptions)  }
                                          placeholder="Please select" />
                            }
                            {
                                treeList[v.type] &&
                                <Spin spinning={ loading }>
                                    {
                                        !loading &&
                                        <div style={{height:'600px',overflow:'auto'}}>
                                        <Tree
                                       
                                            // onCheck={ handleTreeCheck }
                                            expandedKeys={this.state.expandedKeys}
                                            onExpand={(expandedKeys,obj)=>{this.onTreeExpand(expandedKeys,obj,treeList[v.type].list)}}
                                            checkable = { false }
                                            checkStrictly = { false }
                                            onSelect = {  selectedKeys => {this.setState({selectedKeys});handleTreeSelect(selectedKeys, v.type)}  }
                                            selectedKeys={this.state.selectedKeys}
                                            defaultExpandedKeys={this.state.selectedKeys}
                                        >
                                            {loop(treeList[v.type].list || [])}
                                        </Tree>
                                        </div>
                                    }
                                    {
                                        treeList[v.type].list && treeList[v.type].list.length < 1 &&
                                        <div>
                                            无数据
                                        </div>
                                    }
                                </Spin>
                            }
                            {
                                v.type == PAPER && treeList[v.type] &&
                                <Pagination
                                    onChange = { handleGetPaperTreeList }
                                    onShowSizeChange={ handleGetPaperTreeList }
                                    size="small"
                                    pageSize = { +treeList[v.type].pagesize }
                                    current = { treeList[v.type].page }
                                    total={ treeList[v.type].total }
                                />
                            }
                        </TabPane>
                    )
                }
            </Tabs>
        )
    }
}
export default withRouter(AllowTabs)



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/allow_tabs/AllowTabs.js